const MESSAGE_TEXT = {
    email_exist: "E-mail is already exist",
    otp_error: 'Please enter the code you received via SMS text message.',
    supportTitle: "We will respond to tickets within 1 business day.",
    successSupportMsg: "Your ticket has been submitted and is being reviewed by our support team, you should receive a response from a customer support agent within 24 business hours"
}

export default MESSAGE_TEXT;